module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-N-patch-shadow.b3d07b07.png";